import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import { useUserContext } from "utils";

import { Article } from "models";

import { Col, Link, Row } from "components";

type TaglistProps = {
  article: Article;
  url: string;
  md?: string;
  dataTestId?: string;
};
export const Taglist = ({ article, url, md, dataTestId }: TaglistProps) => {
  const { user } = useUserContext();

  return (
    <Row>
      <Col sm={24} md={md || 24}>
        <div className="tag-container" data-testid={dataTestId}>
          <ScrollContainer className="tag-list">
            {article.modules
              .filter((e) => e)
              .map((item, i) => (
                <Link className="bordered" key={`method-${i}`} to={user ? `/search/${url}/${item.link}` : `/search/${url}/${item.link}`}>
                  #{item.module}
                </Link>
              ))}
            {article.tags.map((item, i) => {
              if (article.tags.length > i + 1) {
                return (
                  <Link
                    className="bordered"
                    key={`tag-${i}`}
                    to={
                      user
                        ? `/search/${url}/${item.tag.trim().replace(/\s+/g, "-").toLowerCase()}`
                        : `/search/${url}/${item.tag.trim().replace(/\s+/g, "-").toLowerCase()}`
                    }
                  >
                    #{item.tag}
                  </Link>
                );
              }
              return (
                <Link
                  key={`tag-${i}`}
                  to={
                    user
                      ? `/search/${url}/${item.tag.trim().replace(/\s+/g, "-").toLowerCase()}`
                      : `/search/${url}/${item.tag.trim().replace(/\s+/g, "-").toLowerCase()}`
                  }
                >
                  #{item.tag}
                </Link>
              );
            })}
          </ScrollContainer>
        </div>
      </Col>
    </Row>
  );
};
